import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { DOCTOR_ROLE } from "./routeConfig";

const doctorRoutes = [
  {
    path: "/doctor/dashboard",
    component: lazy(() => import("../Pages/Doctor/OfficeDashboard")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/office-dashboard",
    component: () => <Navigate to="/doctor/dashboard" replace />,
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/healink-impact",
    component: lazy(() => import("../Pages/Doctor/HealinkImpact")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/treatment-coordination",
    component: lazy(() => import("../Pages/Doctor/TreatmentCoordination")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/patients",
    component: lazy(() => import("../Pages/Doctor/Patients")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/practices",
    component: lazy(() => import("../Pages/Doctor/Practices")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/patient/:patientId/visits",
    component: lazy(() => import("../Pages/Doctor/Patients/Visits")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
  {
    path: "/doctor/patient/:patientId/patientChart/:practicePatientUuid",
    component: lazy(() => import("../Pages/Doctor/Patients/VisitRecords")),
    isPublic: false,
    exact: true,
    role: [DOCTOR_ROLE],
  },
];

export default doctorRoutes;
